import { jsonp } from '@/libs/network.js';
import platform from '@/libs/platform.js';
import AppHeader from '@/components/AppHeader/index.vue';
import AppFooter from '@/components/AppFooter/index.vue';
import Swiper from 'swiper';
import GoTop from '@inotom/vue-go-top';

export default {
  name: 'home',
  metaInfo: {
    title: '金融城 CFCITY'
  },
  components: {
    AppHeader,
    AppFooter,
    GoTop
  },
  data () {
    return {
      t1: false,
      t2: false,
      t3: false,
      gallery: {},//轮播图
      module: [],//组件列表
      // navBarFixed: false
    }
  },
  methods: {
    handleToggleDrawer () {
      this.$refs.drawerLayout.toggle();
    },
    // watchScroll () {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   //  当滚动超过 50 时，实现吸顶效果
    //   console.log(scrollTop);
    //   if (scrollTop > 1000) {
    //     this.navBarFixed = true
    //   } else {
    //     this.navBarFixed = false
    //   }
    // }
  },
  mounted() {

    console.log('here')
    let self = this;
    jsonp('/homepage', {
      'callback': 'home'
    }).then(res => {
      let _d = res.data;
      self.gallery = _d.gallery_list[0];
      self.module = _d.module_list;
    }, err => {
      console.log(err);
    });

    if( platform.ismobile ){

      console.log('h5 mounted home')

      setTimeout( () => {
        new Swiper('.focus-slide .swiper-container', {
          centeredSlides: true,
          grabCursor: true,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        });
      } , 500);

    }else{

      setTimeout( () => {
        new Swiper('.focus-slide .swiper-container', {
          centeredSlides: true,
          grabCursor: true,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        });
      } , 500);

      // window.addEventListener('scroll', this.watchScroll);

      console.log('pc mounted home')

    }



    // get('/home').then(res => {
    //   console.log(`get: ${res.body.field_1}`);
    // }, err => {
    //   console.log(err);
    // });

    // post('/list').then(res => {
    //   console.log(`post: ${res.body.field_2}`);
    // }, err => {
    //   console.log(err);
    // });

  },
  computed: {
    isMobile () {
      return this.$store.state.isMobile
    },
    isIphone () {
      return this.$store.state.isIphone
    },
    navBarFixed () {
      return this.$store.state.navBarFixed
    }
  }
}
